export enum DELETE_EVENTS_ACTIONS {
  DELETE = "DELETE_EVENTS_ACTIONS.DELETE",
}
